export const environment = {
    production: false,
    StarAPIURL: 'https://cfcustarapi-testing.azurewebsites.net/',
    appID: 'eff6a92f-da2c-49f5-a57f-243105c120fb',
    scopes: ['https://cfcustarapi-testing.azurewebsites.net/user_impersonation'],
    redirectUri: 'https://star-test.connectfirstcreditunion.net/home'
};
